// extracted by mini-css-extract-plugin
module.exports = {"crossSiteLabel":"Xx-z","zenCrossSiteLabel":"Yx-z","vrsnlCrossSiteLabel":"Zx-z"};